import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { person1, person2, person3, person4, person5, person6 } from "../../assets/img";

const baseWinners = [
  { name: "Rahul Sharma", prize: "₹25,00,000", img: person1 },
  { name: "Priya Mishra", prize: "₹10,00,000", img: person2 },
  { name: "Suresh Iyer", prize: "₹5,00,000", img: person3 },
  { name: "Meena Raj", prize: "₹50,000", img: person4 },
  { name: "Karthik Rao", prize: "₹75,000", img: person5 },
  { name: "Anitha Devi", prize: "₹1,00,000", img: person6 },
];

// Duplicate list → 20 winners
const winners = Array.from({ length: 20 }, (_, i) => ({
  ...baseWinners[i % baseWinners.length],
  ticket: 1000 + i
}));

const WinnersLottery = () => {
  return (
    <div className="ticket-grid-container1">
      <h2 className="ticket-title">🎟️ Winner Lottery Tickets</h2>

      <div className="row">
        {winners.map((w, i) => (
          <div key={i} className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div className="ticket-card2">
              <div className="ticket-shape2">

                <img src={w.img} alt={w.name} className="ticket-img2" />

                <h3 className="ticket-name2">{w.name}</h3>

                <div className="ticket-prize2">
                  <CurrencyRupeeIcon />
                  <span>{w.prize}</span>
                </div>

                <p className="ticket-id2">Ticket No: WIN-{w.ticket}</p>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WinnersLottery;
